import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const WarningIcon = React.memo(function WarningIcon(props: TWarningIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Warning" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.4815 16.5765L11.2138 5.37122C11.1234 5.20959 10.8908 5.20959 10.8004 5.37122L4.53265 16.5765C4.44435 16.7344 4.55846 16.929 4.73936 16.929H17.2748C17.4557 16.929 17.5698 16.7344 17.4815 16.5765ZM12.5229 4.63896C11.8599 3.45368 10.1542 3.45368 9.49125 4.63896L3.22353 15.8443C2.57595 17.002 3.41282 18.429 4.73936 18.429H17.2748C18.6013 18.429 19.4382 17.002 18.7906 15.8443L12.5229 4.63896ZM10.9016 13.429C10.6254 13.429 10.4016 13.2051 10.4016 12.929V8.929C10.4016 8.65286 10.6254 8.429 10.9016 8.429H11.1126C11.3887 8.429 11.6126 8.65286 11.6126 8.929V12.929C11.6126 13.2051 11.3887 13.429 11.1126 13.429H10.9016ZM10.4016 15.429C10.4016 15.7051 10.6254 15.929 10.9016 15.929H11.1126C11.3887 15.929 11.6126 15.7051 11.6126 15.429V14.929C11.6126 14.6529 11.3887 14.429 11.1126 14.429H10.9016C10.6254 14.429 10.4016 14.6529 10.4016 14.929V15.429Z"
            />
        </IconBase>
    );
});

export default WarningIcon;

// #region Types

export type TWarningIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <WarningIcon /> : { ...IconBaseExample, render: WarningIcon };

// #endregion
